// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { TemplateParam } from './TemplateParam';
/**
 * 运行期模版 实体类
 * 运行期模版
 */
export class FileTemplate extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 编码 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 模版内容 : 模版内容 */
  private _content: string;

  /** 设置：模版内容 */
  public get content() {
    return this._content;
  }

  /** 获取：模版内容 */
  public set content(value: string) {
    this._content = value;
  }

  /** 说明 : 说明 */
  private _description: string;

  /** 设置：说明 */
  public get description() {
    return this._description;
  }

  /** 获取：说明 */
  public set description(value: string) {
    this._description = value;
  }

  /** 参数 */
  private _templateParams: Array<TemplateParam>;

  /** 获取：参数 */
  public get templateParams() {
    return this._templateParams;
  }

  /** 设置：参数 */
  public set templateParams(value: Array<TemplateParam>) {
    this._templateParams = value;
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._content = '';
    this._description = '';
    this._templateParams = new Array<TemplateParam>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: FileTemplate, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.content = element.content;
      this.description = element.description;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.content = json.Content;
    this.description = json.Description;
    if (json.TemplateParams && json.TemplateParams.length > 0) {
      json.TemplateParams.forEach((element: any) => {
        const templateParam = TemplateParam.Create(element);
        // templateParam.template = this;
        this.templateParams.push(templateParam);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Content = this.content;
    json.Description = this.description;
    if (this.templateParams && this.templateParams.length > 0) {
      json.TemplateParams = [];
      this.templateParams.forEach((element) => {
        json.TemplateParams.push(element.toJson());
      });
    }
  }

  static Create(json: any): FileTemplate {
    const fileTemplate = new FileTemplate();
    fileTemplate.Deserialize(json);
    fileTemplate.json = json;
    return fileTemplate;
  }
}
